"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = (config, instance) => ({
  getProfile() {
    return instance.get('/proprietary/v2/profiles/current', {
      baseURL: config.apiPrefixes.pcasIdp
    });
  }
});
exports.default = _default;